import { useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';

declare global {
    interface Window {
        pdfjsWorkerInitialized?: boolean;
    }
}

export default function usePdfWorker() {
    const [workerReady, setWorkerReady] = useState(false);

    useEffect(() => {
        if (typeof window === 'undefined') return; // Skip SSR

        const initializeWorker = () => {
            try {
                pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
                setWorkerReady(true);
            } catch (error) {
                console.error('PDF worker initialization failed:', error);
            }
        };

        if (!window.pdfjsWorkerInitialized) {
            window.pdfjsWorkerInitialized = true;
            initializeWorker();
        } else {
            setWorkerReady(true);
        }
    }, []);

    return workerReady;
}
